module.exports = __webpack_public_path__ + "img/smile1.aff9e062.png";